import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ResetPasswordForm, ResetPasswordFormProps } from 'record-it-components/form/ResetPasswordForm/ResetPasswordForm';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { useSpecificParams } from 'record-it-components/hooks/useSpecificParams/useSpecificParams';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
export type ResetPasswordPageProps = PropsWithoutChildren<Record<never, never>>;
export const ResetPasswordPage: FunctionComponent<ResetPasswordPageProps> = React.memo(props => {
  const $ = _c(11);
  prepareProps({
    props,
    ignoreChildren: true
  });
  const navigate = useNavigate();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      requiredParamNames: ["token"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    token
  } = useSpecificParams(t0);
  let t1;
  if ($[1] !== token) {
    t1 = async newPassword => {
      await ApiAdapter.resetPassword({
        token,
        newPassword
      });
    };
    $[1] = token;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resetPassword = useEventCallback(t1);
  let t2;
  if ($[3] !== navigate) {
    t2 = () => {
      navigate(RoutePaths.loginPage());
    };
    $[3] = navigate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCancel = useEventCallback(t2);
  let t3;
  if ($[5] !== navigate) {
    t3 = () => {
      navigate(RoutePaths.loginPage());
    };
    $[5] = navigate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleFinish = useEventCallback(t3);
  let t4;
  if ($[7] !== handleCancel || $[8] !== handleFinish || $[9] !== resetPassword) {
    t4 = <ResetPasswordForm resetPassword={resetPassword} onCancel={handleCancel} onFinish={handleFinish} data-testid="ResetPasswordPage.ResetPasswordForm" />;
    $[7] = handleCancel;
    $[8] = handleFinish;
    $[9] = resetPassword;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});